export default "__VITE_ASSET__KyGUXNTI__"